import React from 'react';
interface CardProps {
  title?: string;
  titleRight?: ReactNode;
  children: ReactNode;
  className?: string;
}
export function Card({
  title,
  titleRight,
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-xl shadow-sm border border-gray-100 p-4 md:p-6 ${className}`} data-id="element-207">
      {(title || titleRight) && <div className="flex items-center justify-between mb-4" data-id="element-208">
          {title && <h2 className="text-lg font-semibold text-gray-900" data-id="element-209">{title}</h2>}
          {titleRight && <div data-id="element-210">{titleRight}</div>}
        </div>}
      <div className="space-y-4" data-id="element-211">{children}</div>
    </div>;
}